import apiClient from '@/plugins/axios';

export default {
	list(params, opts = {}) {
		return apiClient.get('v1/Building', {params, ...opts});
	},

	getBuildings(params) {
		let query = '?';
		Object.entries(params).forEach(([key, value]) => {
			if (key === 'currentPage') {
				key = 'pageNumber';
			}

			query += value ? `${key}=${value}&` : '';
		});

		return apiClient.get(`v1/Building${query}`);
	},

	getBuilding(buildingId) {
		return apiClient.get(`v1/Building/${buildingId}`);
	},

	createBuilding(building) {
		return apiClient.post('v1/Building', building);
	},

	updateBuilding(building) {
		var buildingId = building.id;

		return apiClient.put(`v1/Building/${buildingId}`, building);
	},

	deleteBuilding(buildingId) {
		return apiClient.delete(`v1/Building/${buildingId}`);
	}
};
